import HTTP from '@/utils/http'

class NotifyModel extends HTTP {
  /**
   * 获取消息列表信息
   *
   */
  getMessageList(params) {
    return this.get({
      url: `/notify/message/list`,
      params,
    })
  }

  /**
   * 批量删除消息
   *
   */
  onDeleteMessage(data) {
    return this.post({
      url: '/notify/message/del',
      data,
    })
  }

  /**
   * @description 消息中心-一键清除未读消息
   * @see http://yapi.dayuan1997.com/project/47/interface/api/3216
   *
   */
  clearUnreadNotice() {
    return this.get({
      url: '/notify/message/read/all',
    })
  }
}

export default NotifyModel
